import React from 'react'
import SoftUITabs from './components/SoftUITabs/SoftUITabs.js'
import AddOns from './components/Tabs/AddOns.js';
import NeedHelpPlansCTA from './components/Tabs/NeedHelpPlansCTA.js';
import RedirectSettings from './components/Tabs/RedirectSettings.js';
import "./plansCompact.css";

const SettingINFO = () => {
  const tabsData = [
    { label: 'Plans page (Need help)', content: <NeedHelpPlansCTA /> },
    { label: 'Add Ons', content: <AddOns  /> },
    { label: 'Upgrade Page Settings', content: <RedirectSettings /> },
  ];

  return (
    <div className="sd-plans-tab">
         <SoftUITabs tabsData={tabsData}/>
    </div>
  )
}

export default SettingINFO
